module.exports = __webpack_public_path__ + "img/1504908024.648a2827.jpg";